import { model, Model } from 'mst-collection';
import { types } from 'mobx-state-tree';

import { LanguageCodesEnum } from '@constants';

export class VideoPlayerSettings extends Model({
  playbackRate: 1,
  subtitlesLanguage: types.maybeNull(
    types.enumeration(Object.values(LanguageCodesEnum)),
  ),
  volume: 1,
}) {
  setPlaybackRate(value: number) {
    this.playbackRate = value;
  }

  setSubtitlesLanguage(value: LanguageCodesEnum | null) {
    this.subtitlesLanguage = value;
  }

  setVolume(value: number) {
    this.volume = value;
  }

  get isEnabledSubtitles() {
    return !!this.setSubtitlesLanguage;
  }
}

export const VideoPlayerSettingsModel = model(VideoPlayerSettings);
